<template>
  <button
    class="btn obituary add-media-cta"
    type="button"
    @click.prevent="trigger()"
  >
    <svg aria-hidden="true" viewBox="0 0 640 512">
      <use href="#photo-film" />
    </svg>
    <span v-text="text" />
  </button>
</template>

<script>
  import { mapActions } from "vuex";
  import { MEDIA_INITIAL } from "../../createCommentStepsHelper";

  export default {
    data() {
      return {
        text: lavendlaObituary.common.addMedia,
      };
    },

    methods: {
      ...mapActions("createComment", ["toggleModal"]),

      trigger() {
        this.toggleModal(MEDIA_INITIAL);
      },
    },

    name: "AddMediaCta",
  };
</script>
